import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneValidator(
  validCodes = ['25', '29', '33', '44']
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const phone = control.value;
    const specificDigits = { '25': ['5', '7', '9'] };
    const cleanedPhone = phone ? phone.replace(/\D/g, '') : '';
    const code = cleanedPhone.slice(0, 2);

    if (!phone) {
      return null;
    }

    if (!validCodes.includes(code)) {
      return { validatePhoneNumber: true };
    }

    /* if (code === '25') {
      const followingDigit = cleanedPhone[2];
      if (!specificDigits[code].includes(followingDigit)) {
        return { validatePhoneNumber: true };
      }
    } */

    return null;
  };
}
